<template>
  <div class="ha-card">
    <div class="ha-title">Hubungkan Akunmu</div>

    <div class="ha-body">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConnectAccountCard'
}
</script>

<style scoped>
.ha-card {
  width: 100%;
  background: #ffffff;
  border: 1px solid #eef2ff;
  border-radius: 16px;
  padding: 16px;
}

.ha-title {
  font-weight: 800;
  color: #374151;
  font-size: 16px;
  margin-bottom: 14px;
}

.ha-body {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.ha-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  width: 100%;
}

@media only screen and (max-width: 600px) {
  .ha-body {
    grid-template-columns: 1fr;
  }
}
</style>
